import { FC } from 'react';
import { Switch } from '@mui/material';
import trpcApi from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import { InvestorAccessPermission } from 'further-types/further-user';
import { useHasPermissions } from 'hooks/ui/usePermissions';
import { RolePermission } from 'further-types/admin-user-role';

type Props = {
  copyIntoSystemEmails: boolean;
  accessPermissions: Array<InvestorAccessPermission>;
  furtherUserId: string;
  investorId: string;
  firmId: string;
};

const EditInvestorAccessGrantEmails: FC<Props> = ({
  copyIntoSystemEmails,
  accessPermissions,
  furtherUserId,
  investorId,
  firmId,
}) => {
  const [canEdit] = useHasPermissions([RolePermission.EditInvestorAccessGrant]);

  const update = trpcApi.investorAccessGrant.update.useMutation(
    useHandleTrpcMutation()({
      successMessage: 'Email setting changed.',
    }),
  );

  const handleChange = async () => {
    update.mutate({
      investorId,
      furtherUserId,
      copyIntoSystemEmails: !copyIntoSystemEmails,
      accessPermissions,
      firmId,
    });
  };

  return (
    <Switch
      id={furtherUserId}
      key={furtherUserId}
      checked={copyIntoSystemEmails}
      disabled={update.isPending || !canEdit}
      onChange={handleChange}
      color="primary"
      inputProps={{ 'aria-label': 'primary checkbox' }}
    />
  );
};

export default EditInvestorAccessGrantEmails;
